import { resolveTheme, NEUTRAL } from '../../designTokens';

// T-13: sektionskort i samma stil som övriga vyer – vit yta, rubrik i Manrope,
// valfri `meta` till höger (länk, siffra, knapp). `flush` tar bort innehållets padding
// för listor som använder ListItem.
export default function SectionCard({ theme, title, meta, children, flush }) {
  const t = theme || resolveTheme();
  return (
    <div style={{ background: t.card_bg, border: `1px solid ${t.card_border}`, borderRadius: t.card_radius, boxShadow: t.card_shadow, overflow: 'hidden' }}>
      <div style={{ padding: '14px 20px', borderBottom: `1px solid ${t.card_border}`, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px' }}>
        <h2 style={{ margin: 0, fontSize: '16px', fontWeight: '700', color: NEUTRAL.ink, fontFamily: 'var(--font-heading)' }}>{title}</h2>
        {meta && <div style={{ flexShrink: 0, fontSize: '12px', color: NEUTRAL.muted }}>{meta}</div>}
      </div>
      <div style={{ padding: flush ? 0 : '16px 20px' }}>{children}</div>
    </div>
  );
}
